export default __webpack_public_path__ + "static/creative-follow-bottom-img-83e00964a03ca6a50b218541d2d66ddd.svg";